import { ReplaySubject } from 'rxjs';

/** A response may only update the exact UI context that requested it. */
export interface AiRequestTicket {
  readonly context: string;
  readonly cancelled: ReplaySubject<void>;
}

export class AiRequestScope {
  private current: AiRequestTicket | null = null;

  begin(context: string): AiRequestTicket {
    this.invalidate();
    return this.current = { context, cancelled: new ReplaySubject<void>(1) };
  }

  owns(ticket: AiRequestTicket): boolean { return this.current === ticket; }

  matches(ticket: AiRequestTicket, context: string): boolean {
    return this.owns(ticket) && ticket.context === context;
  }

  invalidate(): void {
    const previous = this.current;
    this.current = null;
    previous?.cancelled.next();
    previous?.cancelled.complete();
  }
}
